<div class="o-grid o-grid--wrap">
	<div class="o-grid__cell o-grid__cell--w-100 c-text c-text--center">
		Redirecting user to: {{vm.targetUrl}}
	</div>
</div>
